/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Week_Rebuild_ChangedInputs */

const en_us2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise changed`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercise changed`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises changed`)
	
};

const pt_br2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício mudou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício mudou`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios mudaram`)
	
};

const es_419_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio cambió`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 ejercicio cambió`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios cambiaron`)
	
};

const pt_pt2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício mudou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercício mudou`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios mudaram`)
	
};

const fr_fr2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice modifié`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 exercice modifié`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices modifiés`)
	
};

const de_de2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung geändert`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Übung geändert`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen geändert`)
	
};

const it_it2_week_rebuild_changed = /** @type {(inputs: Week_Rebuild_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio cambiato`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 esercizio cambiato`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi cambiati`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 exercise changed" |
* | "-1" | "1 exercise changed" |
* | * | "{count} exercises changed" |
*
* @param {Week_Rebuild_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const week_rebuild_changed = /** @type {((inputs: Week_Rebuild_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Rebuild_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_week_rebuild_changed(inputs)
	if (locale === "es-419") return es_419_week_rebuild_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_week_rebuild_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_week_rebuild_changed(inputs)
	if (locale === "de-DE") return de_de2_week_rebuild_changed(inputs)
	if (locale === "it-IT") return it_it2_week_rebuild_changed(inputs)
	return en_us2_week_rebuild_changed(inputs)
});
export { week_rebuild_changed as "week.rebuild.changed" }